import { useSelector } from "react-redux";
import CommonHeader from "../../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import useRolesColumns from "./Hooks/useRolesColumns";
import { useEffect, useState } from "react";
import NewRoleModal from "./NewRoleModal";
import {
  btnAccessChecker,
  checkAccessPermission,
  checkButtonAccess,
  getEntityType,
  getOrgId,
  getOrgType,
} from "../../../../Utils/CommonUtils";
import RolesFilter from "./RolesFilter";
import { getRoleList } from "./RolesService";
import { useDispatch } from "react-redux";
import { resetFormState } from "../../../../slices/common/reducer";
import {
  setRoleFilterForm,
  setRolesData,
  setRoleSorting,
} from "../../../../slices/team/roles/rolesSlice";
import { getFilteredDataWithTabs } from "../../../../Utils/CommonService";

const RolesList = () => {
  const dispatch = useDispatch();
  const { rolesColumns } = useRolesColumns();

  const rolesData = useSelector((state) => state.roles.rolesData);
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const selector = useSelector((state) => state.moduleaccesstree);
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  // const organizationId = getOrgId();
  const organizationType = getEntityType();
  const filterApi = useSelector((state) => state.roles.filter.filterApi);
  const filterForm = useSelector((state) => state.roles.filter.form);
  const sortColumn = useSelector((state) => state.roles.sorting.column);
  const sortOrder = useSelector((state) => state.roles.sorting.order);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);

  // useEffect(() => {
  //   getRoleList(organizationId, organizationType);
  //   dispatch(resetFormState());
  // }, [organizationId, dispatch, triggerRender]);

  console.log("Entity Type:", selectedUser.entitytype);
  console.log("Owner ID:", selectedUser.owner_id);

  const ownerId =
    selectedUser.entitytype === "AGRP" || selectedUser.entitytype === "PSP"
      ? selectedUser.owner_id
      : null;

  useEffect(() => {
    dispatch(setRoleFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      <CommonHeader
        title={"All Roles"}
        newButton={true}
        // checkAccessCreate={checkAccessPermission("CREATE", "TEM_ROL", accessData)}
        checkAccessCreate={checkButtonAccess("CREATE", "TEM_ROL")}
        deletebtn={true}
        buttonTitle={"New Role"}
        filterComponent={<RolesFilter />}
        dash={true}
      />
      <div>
        {/* <TableWrapper
          columns={rolesColumns}
          data={rolesData}
          totalRows={totalRows}
          hideTabs
        /> */}
        <TableWrapper
          columns={rolesColumns}
          data={rolesData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"ROL"}
          filterApiListEntity={"ROL"}
          filterApiFunction={setRolesData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setRoleSorting}
          organizationId={selectedUser.organizationid}
          orgType={selectedUser.organization_type}
          ownerId={ownerId}
        />
      </div>

      {(modalShow || editShow) && <NewRoleModal />}
    </div>
  );
};

export default RolesList;
